// extracted by mini-css-extract-plugin
module.exports = {"container":"graphic_card_container__1BK3J","iconArea":"graphic_card_iconArea__uuq5C","infoArea":"graphic_card_infoArea__2G2iG","number":"graphic_card_number__hTwxu"};